import { LabClient, LabCaseRunPrintOptionsModel } from '@app/api2/api';
import { Formik } from 'formik';
import * as React from 'react';
import { ChangeObserver } from './ChangeObserver';
import { LabPrintingOptionsView } from './LabPrintingOptionsView';

interface ILabPrintingOptionsProps {
    labId: number;
    readOnly: boolean;
    onChange?: (values: LabCaseRunPrintOptionsModel) => any;
    model?: LabCaseRunPrintOptionsModel;
}



export const LabPrintingOptions: React.FunctionComponent<ILabPrintingOptionsProps> = (props) => {
    const labClient = new LabClient();
    const [printingOptions, setPrintingOptions] = React.useState(props.model ?? {} as LabCaseRunPrintOptionsModel);
    const t = window.translation;

    React.useEffect(() => {
        async function fetch() {
            let res = await labClient.getPrintingOptions(props.labId);
            setPrintingOptions(res);
        }

        if (!props.model)
            fetch();

    }, [props.labId, props.model])

    const onFormChange = (values: LabCaseRunPrintOptionsModel) => {
        if (props.onChange)
            props.onChange(values);
    }

    return <>
        <Formik
            initialValues={printingOptions}
            enableReinitialize={true}
            onSubmit={(values) => {
            }}>
            {({ values }) => (<>
                <ChangeObserver value={values} onChange={values => onFormChange(values)} />
                <LabPrintingOptionsView readOnly={props.readOnly} options={printingOptions}></LabPrintingOptionsView></>
            )}
        </Formik>
    </>;
};




